import { render } from "./WaitChangeEmail.vue?vue&type=template&id=62a0ef9c"
import script from "./WaitChangeEmail.vue?vue&type=script&lang=js"
export * from "./WaitChangeEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__